import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import * as moment from 'moment';
import { HamodelModel } from '../../../model/index';
import { stockUpdateModel } from '../../../model/index';
import { HamodelService, CommonService } from '../../../services/index';

@Component({
    selector: 'stock-tab',
    templateUrl: './stocklist.component.html',
})
export class AddUpdateStockComponent implements OnInit {
    @Input() stockGrid: stockUpdateModel[] = [];
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    
    
    public mode: string;
    public list: any[] = [];
    public stockList: any[] = [];


    serialNoList: any[] = [];
    halistCtrl: FormControl;
    filteredHa: Observable<any[]>;
    haList: any[] = [];
    actSerialNoList = [];
    serialNoCtrl: FormControl;
    qty_type : any[];
    filteredSerialNo: Observable<any[]>;


    partyCtrl: FormControl;
    typeCtrl: FormControl;
    numCtrl: FormControl;
    mrpCtrl: FormControl;
    modelCtrl: FormControl;
    dateCtrl: FormControl;
    branchCtrl: FormControl;
    amtCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    isLoadMask: Promise<any>;
    // stockDet: HamodelModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    loadingIndicator: boolean = true;
    //reorderable: boolean = true;
    filteredParty: Observable<any[]>;
    filteredModel: Observable<any[]>;
    PartyList = [];
    ModelList = [];
    typeList = [];
    paymentList = [];
    actModelList = [];
    stockDet = [];
    branchList: any[] = [];

    // @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    // @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('halistAutoComp') halistAutoComp;
    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    showBranch = true;
    subscribeBranch;
    showUpdate: boolean;
    isUpdateMrp: boolean = false;
    constructor(public store: Store<fromRootStore.State>, private hamodelService: HamodelService, public toasterService: ToasterService, private commonService: CommonService) {
        //FOR AUTO COMPLETE VALIDATION --- PARTY COMBO
        this.partyCtrl = new FormControl('', [
            Validators.required,
        ]);
this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;

            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.filteredHa = this.halistCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterHa(name) : this.haList.slice());

        //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
        function hasValidModel(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidModel: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidModel: true };
            }
            return retVal;
        }

        this.modelCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);
        this.serialNoCtrl = new FormControl();
        this.filteredSerialNo = this.serialNoCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterSerialNo(name) : this.serialNoList.slice());

        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "HA Model" && ledgerID != "Spare") {
                retVal = { inValidType: true };
            }
            return retVal;
        }
        this.typeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        this.typeCtrl = new FormControl('', [
            Validators.required
        ]);
        this.numCtrl = new FormControl('', [
            Validators.required,
        ]);
        this.mrpCtrl = new FormControl('', [
            Validators.required,
        ]);
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }
    displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }

    ngOnInit(): void {
        this.typeList = ['Update Stock', 'Update MRP'];
        this.qty_type = ['Available', 'HV-SOA'];
      
        this.subscribeBranch = this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        });
        this.loadChallanHaList();
        this.halistAutoComp.optionSelected.subscribe(this.onSelectedHaList.bind(this));

    }
    filterHa(name: string) {
        name = _.escapeRegExp(name);
        return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }
    loadChallanHaList() {
        let that = this,
            data = {
                from_page: 'Ha_and_spare'
            };
        this.commonService
            .getHaModelStock(data)
            .then(function (res: any) {
                that.haList = res['haStockModel'];
                that.actSerialNoList = res['haModelStockSerial'];
                that.halistCtrl.setValue(that.stockDet['model_id']);
            });
    }

    displayHa(model_id: number) {
        this.serialNoList = [];
        if (model_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'model_id': model_id });
            this.getModelSerialNo(model_id); //TO LOAD SERIAL NUMBER FOR THAT MODEL
            return fhalist['name'];
        }
        return '';
    }

    onSelectedHaList(mdCompEvent: any) {
        let model_id = mdCompEvent.option.value,
            fhalist = _.find(this.haList, { 'model_id': model_id });

        this.stockDet['name'] = fhalist.name;
    }
   
    filterSerialNo(name: string) {
        name = _.escapeRegExp(name);
        return this.serialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));
    }
    displaySerialNo(serial_no: number) {
        if (serial_no && this.serialNoList.length > 0) {
            let fhalist = _.find(this.serialNoList, { 'serial_no': serial_no });
            this.stockDet['model_id'] = fhalist.model_id;
            this.stockDet['serial_no'] = fhalist.serial_no;
            return fhalist['serial_no'];
        }
        return '';
    }
    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    onStockTypeChange(stockType: string): void {
        this.isUpdateMrp = (stockType === 'Update MRP');
        // Reset fields when changing stock type
        if (this.isUpdateMrp) {
            this.stockDet['qty'] = '';
            this.stockDet['type'] = '';
        } else {
            this.stockDet['mrp'] = '';
        }
    }
    getModelSerialNo(modelID) {
        let actSerialNoList = this.actSerialNoList;
        this.serialNoList = _.filter(actSerialNoList, { 'model_id': modelID });
        this.serialNoCtrl.setValue(this.stockGrid['model_id']);
    }

    onStockAddUpdate(): void {
        var toast = {
            type: 'error',
            title: 'ERROR'
        };

        let that = this, data;

        if (this.isUpdateMrp) {
            // Update MRP Mode
            data = {
                stock_type: this.stockDet['stock_type'],
                model: this.stockDet['model_id'],
                serial_no: this.stockDet['serial_no'],
                mrp: this.stockDet['mrp']
            };

            if (data.stock_type == undefined || data.stock_type == '') {
                swal('WARNING', 'Please select StockType');
                return;
            }
            if (data.model == undefined || data.model == '') {
                swal('WARNING', 'Please Select Model Name');
                return;
            }
            if (data.serial_no == undefined || data.serial_no == '') {
                swal('WARNING', 'Please select Serial No');
                return;
            }
            if (data.mrp == undefined || data.mrp == '') {
                swal('WARNING', 'Please Enter MRP');
                return;
            }
        } else {
            // Update Stock Mode
            if(this.stockDet['type'] == 'Available'){
                this.stockDet['type'] = 'avail_qty';
            }else if(this.stockDet['type'] == 'HV-SOA'){
                this.stockDet['type'] = 'hv_soa_qty';
            }

            data = {
                stock_type: this.stockDet['stock_type'],
                model: this.stockDet['model_id'],
                serial_no:this.stockDet['serial_no'],
                qty : this.stockDet['qty'],
                type : this.stockDet['type'],
                branch_id:this.stockDet['branch_id'],
            };

            if (data.stock_type == undefined || data.stock_type == '') {
                swal('WARNING', 'Please select StockType');
                return;
            }
            if (data.model == undefined || data.model == '') {
                swal('WARNING', 'Please Select Model Name');
                return;
            }
            if (data.serial_no == undefined || data.serial_no == '') {
                swal('WARNING', 'Please select Serial No');
                return;
            }
            if (data.qty == undefined || data.qty == '') {
                swal('WARNING', 'Please Enter Quantity');
                return;
            }
            if (data.type == undefined || data.type == '') {
                swal('WARNING', 'Please Select Type of Stock');
                return;
            }
            if (data.branch_id == undefined || data.branch_id == '') {
                swal('WARNING', 'Please Enter Branch');
                return;
            }
        }

        swal({
            title: 'Are you sure to Update?',
            showCancelButton: true,
            confirmButtonText: 'Yes, Update!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoading = true;
            that.isLoadMask = that.commonService
            .UpdateStockDet(data)
                .then(function(res: any) {

                    that.isLoading = false;
                    if (res.success) {
                        that.stockDet = [];
                        that.isUpdateMrp = false;
                        swal('SUCCESS', res.message, 'success');
                    } else {

                        var toast = {
                            type: 'error',
                            title: 'ERROR',
                            body: res.message
                        };
                        that.toasterService.pop(toast);
                    }
                });

        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/stockUpdate/stocklist.component.ts